import {
    Box,
    Paper,
    Typography,
    useMediaQuery
} from "@mui/material";
import React from 'react';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
  
  const Seamless = () => {
      const isNonMobile = useMediaQuery("(min-width:600px)");
  
    return   <Box sx={{ p: 2, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
      <Paper sx={{ p: isNonMobile ? 3 : 2, borderRadius: 2 }}>
          <Typography variant="h4" fontWeight="bold"gutterBottom>
            심리스 (통합형 지갑)
          </Typography>
      {/* <SwaggerUI url="/swagger/developers/seamless.yaml" /> */}
      <SwaggerUI url="swagger-seamless.yaml" />
      </Paper>
    </Box>;
  };
  
  export default Seamless;
  